export default __webpack_public_path__ + "static/media/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.d4600fe3.ttf";